<template>
<div class="chapter">
<div class="inner_page">
<div class="sgc-toc-title">Table of Contents</div>
<div class="sgc-toc-level-1">
<a href="#/Text/TitlePage">Start</a>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<a href="#/Text/M">M</a>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/N" title="Link target outside of Sample">N</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/OP" title="Link target outside of Sample">O-P</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/QR" title="Link target outside of Sample">Q-R</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/S1" title="Link target outside of Sample">S</span>
</div>
<div class="sgc-toc-level-1"><br/></div>
<div class="sgc-toc-level-1">
<span href="#/Text/Bibliography" title="Link target outside of Sample">Bibliography</span>
</div>
<div class="sgc-toc-level-1">
<span href="#/Text/Index" title="Link target outside of Sample">Index</span>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?76bdf6bf